import { composeIO } from 'react-compose-io'
import { itemHistoricoRegularizacaoIO } from './ItemHistoricoRegularizacao.IO'
import { ItemHistoricoRegularizacaoView } from './ItemHistoricoRegularizacao.View'

export const ItemHistoricoRegularizacao = composeIO(ItemHistoricoRegularizacaoView, itemHistoricoRegularizacaoIO)
